"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _kycLevelsSelectors = require("../../../redux/selectors/kycLevelsSelectors");
var _sidePaneActions = require("../../../redux/actions/sidePaneActions");
var _snackbarActions = require("../../../redux/actions/snackbarActions");
var _APIFrame = _interopRequireDefault(require("../../common/APIFrame/APIFrame"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var KYC_AGIframeComponent = function KYC_AGIframeComponent(_ref) {
  var iframe = _ref.iframe;
  return /*#__PURE__*/_react["default"].createElement(_APIFrame["default"], {
    id: "acuant-go-iframe",
    src: iframe
  });
};
var mapStateToProps = function mapStateToProps(state, props) {
  var level = props.level;
  var _kycLevelFormSelector = (0, _kycLevelsSelectors.kycLevelFormSelector)(state),
    verificationLevel = _kycLevelFormSelector.verificationLevel,
    kycConfig = _kycLevelFormSelector.kycConfig,
    kyc = _kycLevelFormSelector.kyc,
    alphaPointSessiontoken = _kycLevelFormSelector.alphaPointSessiontoken,
    alphaPointUserID = _kycLevelFormSelector.alphaPointUserID,
    userConfig = _kycLevelFormSelector.userConfig,
    userName = _kycLevelFormSelector.userName,
    processing = _kycLevelFormSelector.processing;
  return {
    level: level,
    processing: processing,
    alphaPointUserID: alphaPointUserID,
    alphaPointSessiontoken: alphaPointSessiontoken,
    kycConfig: kycConfig,
    userName: userName,
    kyc: kyc,
    userConfig: userConfig
  };
};
var mapDispatchToProps = {
  closeSidePane: _sidePaneActions.closeSidePane,
  showSnack: _snackbarActions.showSnack
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(KYC_AGIframeComponent);